module.exports = __webpack_public_path__ + "img/watering.23e854e4.png";